import clsx from 'clsx';

export interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
  className?: string;
}

const headerWidths = ['w-[20%]', 'w-[25%]', 'w-[15%]', 'w-[20%]', 'w-[10%]', 'w-[18%]', 'w-[22%]', 'w-[12%]'];
const bodyWidths = [
  ['w-[60%]', 'w-[80%]', 'w-[45%]', 'w-[70%]', 'w-[55%]', 'w-[65%]', 'w-[50%]', 'w-[75%]'],
  ['w-[75%]', 'w-[50%]', 'w-[65%]', 'w-[40%]', 'w-[70%]', 'w-[55%]', 'w-[80%]', 'w-[60%]'],
  ['w-[50%]', 'w-[70%]', 'w-[55%]', 'w-[85%]', 'w-[45%]', 'w-[75%]', 'w-[60%]', 'w-[50%]'],
  ['w-[65%]', 'w-[45%]', 'w-[75%]', 'w-[55%]', 'w-[80%]', 'w-[40%]', 'w-[70%]', 'w-[65%]'],
  ['w-[55%]', 'w-[85%]', 'w-[40%]', 'w-[60%]', 'w-[50%]', 'w-[70%]', 'w-[45%]', 'w-[80%]'],
];

export const TableSkeleton = ({
  rows = 5,
  columns = 4,
  showHeader = true,
  className,
}: TableSkeletonProps) => {
  return (
    <div
      className={clsx(
        'animate-pulse space-y-3 rounded-lg border border-gray-200 dark:border-gray-700 p-4',
        className
      )}
    >
      {showHeader && (
        <div className="flex gap-4 pb-3 border-b border-gray-200 dark:border-gray-700">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className={clsx(
                'h-3 rounded bg-gray-300 dark:bg-gray-600 flex-1',
                headerWidths[colIndex % headerWidths.length]
              )}
            />
          ))}
        </div>
      )}

      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex gap-4">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div key={colIndex} className="flex-1">
              <div
                className={clsx(
                  'h-4 rounded bg-gray-200 dark:bg-gray-700',
                  bodyWidths[rowIndex % bodyWidths.length][colIndex % bodyWidths[0].length]
                )}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
